import PropTypes from 'prop-types';
import Grid from '@material-ui/core/Grid';
import { withStyles } from '@material-ui/core/styles';
import React from 'react';
import { globalStyles as styles } from '../../core/style/gstheme';
import ApplicationCard from '../applications/ApplicationCard';
import BasicLayout from '../BasicLayout';
import { UserConsumer } from '../providers/UserProvider';
import { ENTITLEMENTS } from '../utils/constants';
import { checkEntitlements } from '../utils/utils';

class DashboardApplications extends React.Component {

  render() {

    return (
      <UserConsumer>
        {({ entitlements, activeSubscription }) => {
          return <BasicLayout title="Dashboard">
            <Grid spacing={2} container justifyContent="space-evenly" classes={
              {
                "spacing-xs-2": this.props.classes.fullGrid
              }
            }>
              {
                checkEntitlements(entitlements, [ENTITLEMENTS.EDIT_USER]) ?
                  <Grid item>
                    <ApplicationCard
                      dataTest="users"
                      id="users"
                      url="/dashboard/users"
                      title="Users"
                      description="Create and manage users."
                      thumbnail="/images/users.svg"
                    />
                  </Grid>
                  :
                  null
              }
              {
                checkEntitlements(entitlements, [ENTITLEMENTS.EDIT_GROUP, ENTITLEMENTS.CREATE_GROUP]) ?
                  <Grid item>
                    <ApplicationCard
                      dataTest="groups"
                      id="groups"
                      url="/dashboard/groups"
                      title="Groups"
                      description="Create and manage user groups."
                      thumbnail="/images/groups.svg"
                    />
                  </Grid>
                  :
                  null
              }
              {
                activeSubscription && checkEntitlements(entitlements, [ENTITLEMENTS.MANAGE_SNAPSHOTS]) ?
                  <Grid item>
                    <ApplicationCard
                      dataTest="snapshot"
                      id="integrations"
                      url="/dashboard/snapshots"
                      title="Snapshots"
                      description="Create and manage project snapshots."
                      thumbnail="/images/snapshot.svg"
                    />
                  </Grid>
                  :
                  null
              }
              {
                activeSubscription && checkEntitlements(entitlements, [ENTITLEMENTS.CAN_QUERY]) ?
                  <Grid item>
                    <ApplicationCard
                      dataTest="sparql"
                      id="sparql"
                      url="/dashboard/sparql"
                      title="SPARQL"
                      description="Query your subscription using SPARQL."
                      thumbnail="/images/query.svg"
                    />
                  </Grid>
                  :
                  null
              }
              {
                activeSubscription && checkEntitlements(entitlements, [ENTITLEMENTS.MANAGE_INTEGRATION]) ?
                  <React.Fragment>
                    <Grid item>
                      <ApplicationCard
                        dataTest="integration"
                        id="integrations"
                        url="/dashboard/integrations"
                        title="Integrations"
                        description="Create and manage integrations."
                        thumbnail="/images/sync.svg"
                      />
                    </Grid>
                    <Grid item>
                      <ApplicationCard
                        dataTest="api"
                        id="api"
                        url="/dashboard/api"
                        title="API"
                        description="View details on how to access the Graphologi API."
                        thumbnail="/images/api.svg"
                      />
                    </Grid>
                  </React.Fragment>
                  :
                  null
              }
            </Grid>
          </BasicLayout>;
        }}
      </UserConsumer>
    );
  }
}

DashboardApplications.propTypes = {
  classes: PropTypes.object
};

export default withStyles(styles)(DashboardApplications);